import styles from "./EnvSwitcher.module.css";

export type DeployEnv = "dev" | "stage" | "prod";

interface EnvSwitcherProps {
  /** The current deployment environment. */
  env: DeployEnv;
}

/**
 * The environment indicator that sits at the top of the app rail. A colored
 * dot (--env-dev/stage/prod) plus the environment name. This is a display
 * indicator, not an environment *changer* — each environment is a separate
 * deployed app (frontend-stack.md: Environment Model).
 */
function EnvSwitcher({ env }: EnvSwitcherProps) {
  return (
    <div className={styles.env} title={`Environment: ${env}`}>
      <span className={styles.dot} data-env={env} />
      <span className={styles.label}>{env}</span>
    </div>
  );
}

export default EnvSwitcher;
